module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_m_albino.57f435b7.png";